export default {
	domain: {
		zonenscherm: 'shop.zonenscherm.nl',
		schipper: 'schipperwebshop.nl'
	},
	api: {
		development: 'zonenscherm-admin-master.test.flaire.nl',
		production: 'admin.zonenscherm.nl',
		endpoint: 'api/configurator'
	},
	shop: {
		development: 'e2-zonscherm-master.test.flaire.nl',
		basket: 'purchase/basket',
		resource: 'e2/zonscherm/site/custom'
	}
};